export const ApiErrors = {
  INVALID_OTP: 'error_code_core_bank_6206',
  INVALID_MOVIMENTS_OTP: 'error_code_otp_svc_2002',
  AUTH_ERROR_OTP_REQUIRED: 'auth_error_otp_required',
  AUTH_ERROR_BAD_REQUEST: 'auth_error_bad_request',
  ERROR_BULKSIGN: 'ERROR_BULKSIGN',
  ERROR_BULKSIGN_REQUESTNEWSUBMIT: 'ERROR_BULKSIGN_REQUESTNEWSUBMIT',
  ERROR_SUBMIT: 'ERROR_SUBMIT',
  KO_RETRY: 'KO_RETRY',
  IMP_NOT_FOUND: 'IMP_NOT_FOUND',
  IMP_NOT_FOUND_350: 'error_code_core_bank_350',
  MOV_NOT_FOUND: 'MOV_NOT_FOUND',
  MOV_NOT_FOUND_350: 'error_code_core_bank_350',
  NO_APPROVAL: "NO_APPROVAL",
} as const;
